<template>
  <el-select v-model="selectValue"
             filterable
             popper-class="data-grid-meta-select"
             v-bind="$attrs"
             v-on="$listeners">
    <el-option v-for="option in filterOptions"
               :key="option[valueProp]"
               :label="option[labelProp]"
               :value="option[valueProp]">
      <div class="custom-option">
        <div class="label">{{option[labelProp]}}</div>
        <div v-if="option[statusProp]"
             class="extra">
          <el-tag size="mini"
                  type="primary">{{option[statusProp]}}</el-tag>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'DataGridMetaSelect',
  props: {
    value: {
      required: true
    },
    labelProp: {
      type: String,
      default: 'label'
    },
    valueProp: {
      type: String,
      default: 'value'
    },
    statusProp: {
      type: String,
      default: 'status'
    },
    options: Array
  },
  computed: {
    filterOptions: function () {
      return this.options || []
    },
    selectValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
.data-grid-meta-select {
  .el-select-dropdown__item {
    padding-left: 15px;
    padding-right: 15px;
  }
  .custom-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &>.extra {
      margin-left: 15px;
    }
  }
}
</style>
